/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import $ from "jquery";
import booking from "../data/booking";
import route from "../helpers/route";

const bookingReserveren = () => {
  const target = ".wb-Reserveren";
  const reserverenBtn = ".js-SingleReserverenBtn";
  const $target = $(target);
  const $reserverenBtn = $(reserverenBtn);

  const el = {
    nextBtn: ".js-ReserverenButton__Next",
    prevBtn: ".js-ReserverenButton__Prev",
    formSubmitBtn: ".js-ReserverenButton__Next.submit",
    paymentSuccessBtn: ".js-PaymentSuccessBtn",
    reserverenBtnSingle: ".js-SingleReserverenBtn",
    reserverenBtnWrapper: ".ReserverenButtonWrapper",
    errorMessage: ".wb-ReserverenErrorMessage",
    stepsHeaderItems: ".ReserverenHeaderSteps__Item",
    bookingFormReserveren: "#bookingFormReserveren",
    reserverenBodyTitle: ".js-ReserverenBodyTitle",
    reserverenStepsCount: ".js-ReserverenStepsCounting",
    firstStep: ".js-DatePickerWrapper",
    cartStep: ".js-BookingCart",
    secondStep: ".js-PersonalInformation",
    thirdStep: ".js-Payment",
    forthStep: ".js-PaymentSuccess",
    bookingForm: ".js-booking-form",
    inputAddress: ".js-AddressItemValue",
    reservationNotes: ".ReservationNotes",
  };

  const init = () => {
    handleShowReservationNotes();
    handleShowMobileInput();
    if ($target.length || $reserverenBtn.length) {
      // const urlParams = new URLSearchParams(window.location.search);
      // const productId = urlParams.get("id");

      // const productTypeItem = {};
      // const productType = urlParams.get("product-type");
      // productTypeItem[productId] = productType;
      // const existingProductType =
      //   JSON.parse(localStorage.getItem("productType")) || {};
      // const updatedProductType = { ...existingProductType, ...productTypeItem };

      // if (productId && !localStorage.getItem("productId")) {
      //   localStorage.setItem("productId", productId);
      //   localStorage.setItem("productType", JSON.stringify(updatedProductType));
      // } else if (productId !== localStorage.getItem("productId")) {
      //   localStorage.removeItem("product");
      //   localStorage.setItem("productId", productId);
      //   localStorage.removeItem("productType");
      //   localStorage.setItem("productType", JSON.stringify(updatedProductType));
      // }

      if (localStorage.getItem("currentStep") === null) {
        localStorage.setItem("currentStep", 1);
      }

      const currentStep = localStorage.getItem("currentStep");

      if (currentStep == 1) {
        $(".ReserverenButtonWrapper").addClass("first-step");
        $("#wb-DatePicker").trigger("change");
      }

      exec();
      getDeliveryFee();
      handleDisableNextBtnStep1();
    }
  };

  const nextMonthDisabled = async (month, year) => {
    let nextMonth = month + 1;
    let nextYear = year;
    if (month == 12) {
      nextMonth = 1;
      nextYear = nextYear + 1
    }

    const disabled = await booking.findAvailableById(route.get("id"), nextMonth, nextYear).done((disabled) => disabled)
    return disabled ?? []
  }

  const exec = async () => {
    $(el.firstStep).addClass("active");
    let currentStep = 1;
    const totalSteps = 4;
    const date = new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    let initialPrice = reformatPriceToInt($(inputSelectors.price).text());

    const blockedNextMonth = await nextMonthDisabled(month, year);

    booking.findAvailableById(route.get("id"), month, year).done((disabled) => {
      try {
      flatpickr("#wb-DatePicker", {
        // defaultDate:'null',
        disableMobile: true,
        dateFormat: "d-m-Y",
        minDate: "today",
        enableTime: false,
        // disable: disabled,
        inline: true,
        mode: "range",
        // defaultDate: [new Date(), new Date(Date.now() + 86400000)],
        locale: Dutch,
        disable: [...disabled, new Date(), new Date().fp_incr(1), ...blockedNextMonth],

        onMonthChange: function (selectedDates, dateStr, instance) {
          (async () => {
            const tempDisabled = await booking.findAvailableById(
              route.get("id"),
              instance.currentMonth + 1,
              instance.currentYear
            );

            const blockedNextMonth = await nextMonthDisabled(instance.currentMonth + 1, instance.currentYear);

            instance.set("disable", [
              ...disabled,
              ...tempDisabled,
              new Date(),
              new Date().fp_incr(1),
              ...blockedNextMonth
            ]);

            // flatPick.set("disable", disabled);
          })();
        },

        onReady: function (selectedDates, dateStr, instance) {
          let defaultDiffDay;
          // to prevent counting error in case of order for only a day
          if (
            isNaN($(".js-AddonsProduct__DiffDays").val()) ||
            $(".js-AddonsProduct__DiffDays").val() == 1
          ) {
            defaultDiffDay = "1";
          } else {
            defaultDiffDay = "2";
          }
          $(".js-AddonsProduct__DiffDays").val(defaultDiffDay);

          $(document).ready(function () {
            // console.warn(
            //   `init default diff: ${JSON.stringify(
            //     $(".js-AddonsProduct__DiffDays").val()
            //   )}`
            // );
            // console.warn(
            //   `init localStorage of totalhuurjs: ${localStorage.getItem(
            //     "totalHuurjs"
            //   )}`
            // );

            let totalHuurjs = localStorage.getItem("totalHuurjs");
            let startingPriceFromTotalHuurjs = parseFloat(totalHuurjs);

            $(".js-ReservationPrice.Huurprijs").text(
              `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
            );

            if ($(".js-DatePickerWrapper").hasClass("active")) {
              $(
                ".ReservationInformation__ItemTextPrice.js-ReservationPrice"
              ).text(
                `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
              );
            }
          });

          const savedDates = JSON.parse(
            localStorage.getItem("reservationDates")
          );
          let startDate, endDate;
          // $(el.nextBtn).addClass("active");

          if (savedDates && savedDates.startDate && savedDates.endDate) {
            startDate = new Date(savedDates.startDate);
            endDate = new Date(savedDates.endDate);
          } else {
            // Comment the code below to prevent the duplication of 1 days default settings
            // $(inputSelectors.price).text(
            //   `€${((1 + 1) * initialPrice)
            //     // `€${(initialPrice)
            //     .toFixed(2)
            //     .replace(".", ",")}`
            // );

            updateTotalPrice();

            // Select Two Days at first
            setTimeout(() => {
              const todayElement = $(".flatpickr-day.today").nextAll().eq(1);
              const tomorrowElement = todayElement.next();

              function formatDate(dateString) {
                const months = {
                  januari: "01",
                  februari: "02",
                  maart: "03",
                  april: "04",
                  mei: "05",
                  juni: "06",
                  juli: "07",
                  augustus: "08",
                  september: "09",
                  oktober: "10",
                  november: "11",
                  december: "12",
                };

                const parts = dateString.split(" ");

                const day = parts[1];
                dateString = day.replace(/,$/, "");
                const month = months[parts[0].toLowerCase()];
                const year = parts[2];

                return `${year}-${month}-${dateString}`;
              }

              if (savedDates && savedDates.startDate && savedDates.endDate) {
                startDate = new Date(savedDates.startDate);
                endDate = new Date(savedDates.endDate);
              }
              // else if(savedDates.endDate === null) {
              //   startDate = new Date(savedDates.startDate);
              //   endDate = new Date(savedDates.startDate);
              //   console.log(`endDate: ${endDate}`);
              // }
              else {
                if (todayElement.hasClass("flatpickr-disabled")) {
                  tomorrowElement.removeClass("selected startRange");
                  const availableDays = $(".flatpickr-day").not(
                    ".flatpickr-disabled, .today, .prevMonthDay"
                  );

                  if (availableDays.length >= 2) {
                    const reservationDates = {};

                    availableDays.slice(0, 2).each(function (index) {
                      const date = $(this).attr("aria-label");

                      if (index === 0) {
                        reservationDates.startDate = date;
                        $(this).addClass("selected startRange");
                      } else if (index === 1) {
                        reservationDates.endDate = date;
                        $(this).addClass("selected endRange");
                      }
                    });

                    reservationDates.startDate = formatDate(
                      reservationDates.startDate
                    );
                    reservationDates.endDate = formatDate(
                      reservationDates.endDate
                    );

                    localStorage.setItem(
                      "reservationDates",
                      JSON.stringify({
                        startDate: reservationDates.startDate,
                        // endDate: reservationDates.endDate,
                      })
                    );

                    $(".ReservationInformation__ItemTextValue.StartDate").text(
                      reservationDates.startDate
                    );
                    $(".ReservationInformation__ItemTextValue.EndDate").text(
                      reservationDates.endDate
                    );
                  }
                } else if (tomorrowElement.hasClass("flatpickr-disabled")) {
                  todayElement.removeClass("selected startRange");
                  tomorrowElement.removeClass("selected startRange");
                  const availableDays = $(".flatpickr-day").not(
                    ".flatpickr-disabled, .today, .prevMonthDay"
                  );

                  if (availableDays.length >= 2) {
                    const reservationDates = {};
                    availableDays.slice(0, 2).each(function (index) {
                      const date = $(this).attr("aria-label");

                      if (index === 0) {
                        reservationDates.startDate = date;
                        $(this).addClass("selected startRange");
                      } else if (index === 1) {
                        reservationDates.endDate = date;
                        $(this).addClass("selected endRange");
                      }
                    });

                    reservationDates.startDate = formatDate(
                      reservationDates.startDate
                    );
                    reservationDates.endDate = formatDate(
                      reservationDates.endDate
                    );

                    localStorage.setItem(
                      "reservationDates",
                      JSON.stringify({
                        startDate: reservationDates.startDate,
                        // endDate: reservationDates.endDate,
                      })
                    );

                    $(".ReservationInformation__ItemTextValue.StartDate").text(
                      reservationDates.startDate
                    );
                    $(".ReservationInformation__ItemTextValue.EndDate").text(
                      reservationDates.endDate
                    );
                  }
                } else {
                  if (todayElement.length > 0) {
                    todayElement.addClass("selected startRange");
                    tomorrowElement.addClass("selected startRange");

                    const todayElementAttr = $(todayElement).attr("aria-label");
                    const tomorrowElementAttr =
                      $(tomorrowElement).attr("aria-label");
                    const reservationDates = {};

                    reservationDates.startDate = formatDate(todayElementAttr);
                    reservationDates.endDate = formatDate(tomorrowElementAttr);
                    // To fix null end date on initial datepicker page, we need to assign endDate as startDate
                    localStorage.setItem(
                      "reservationDates",
                      JSON.stringify({
                        startDate: reservationDates.startDate,
                        endDate: reservationDates.startDate,
                      })
                    );

                    $(".ReservationInformation__ItemTextValue.StartDate").text(
                      reservationDates.startDate
                    );
                    $(".ReservationInformation__ItemTextValue.EndDate").text(
                      reservationDates.endDate
                    );
                  }
                }
              }
            }, 0);
          }
          // Store the correct startDate and endDate in localStorage
          // saveDatesToLocalStorage(instance, startDate, endDate);
          // Set the selected range in Flatpickr
          instance.setDate([startDate, endDate]);

          // Update displayed dates and localStorage
          updateDisplayedDates(instance, startDate, endDate);
          // saveDatesToLocalStorage(instance, startDate, endDate);
        },

        onChange: function (selectedDates, dateStr, instance) {
          $(el.nextBtn).addClass("active");
          if (selectedDates.length === 2) {
            const startDate = instance.formatDate(selectedDates[0], "Y-m-d");
            const endDate =
              selectedDates.length === 2
                ? instance.formatDate(selectedDates[1], "Y-m-d")
                : startDate;

            localStorage.setItem(
              "reservationDates",
              JSON.stringify({ startDate, endDate })
            );

            const diffInDays =
              (selectedDates[1] - selectedDates[0]) / (1000 * 60 * 60 * 24);
            if (diffInDays < 1) {
              $(el.nextBtn).addClass("active");
            } else {
              $(el.errorMessage).removeClass("active");
              $(el.nextBtn).addClass("active");
            }

            // initialPrice = initialPrice + ((initialPrice / 2) * (diffInDays - 1));
            $(inputSelectors.price).text(
              `€${((diffInDays + 1) * initialPrice)
                // `€${((diffInDays) * initialPrice)
                .toFixed(2)
                .replace(".", ",")}`
            );

            const startDateText = startDate.split("-").reverse().join("-");
            const endDateText = endDate.split("-").reverse().join("-");

            $(".ReservationInformation__ItemTextValue.StartDate").text(
              startDateText
            );
            $(".ReservationInformation__ItemTextValue.EndDate").text(
              endDateText
            );

            // SAVE DIFFERENCE DAYS ON HIDDEN ELEMENT
            const reservationDatesData = JSON.parse(
              localStorage.getItem("reservationDates")
            );

            const start = new Date(reservationDatesData.startDate);
            const end = new Date(reservationDatesData.endDate);

            const timeDifference = end - start;

            $("#deposit_fee").text("€0");
            const dayDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
            $(".js-AddonsProduct__DiffDays").val(dayDifference);

            updateTotalPrice();

            let totalHuurjs = localStorage.getItem("totalHuurjs");

            let startingPriceFromTotalHuurjs = parseFloat(totalHuurjs);

            $(
              ".ReservationInformation__ItemTextPrice.js-ReservationPrice"
            ).text(
              `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
            );
            $(".js-ReservationPrice.Huurprijs").text(
              `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
            );
          }
        },

        onDayCreate: function (dObj, dStr, fp, dayElem) {
          fp.config.disable.forEach(function (dateRange) {
            const from = new Date(dateRange.from);
            const to = new Date(dateRange.to);

            if (dayElem.dateObj >= from && dayElem.dateObj <= to) {
              $(dayElem).addClass("booked-date");
            }
          });
        },
      });

      // Mobile Date Picker
      // Start Date Picker
      flatpickr("#mobileStartDatePicker", {
        dateFormat: "d-m-Y",
        minDate: "today",
        enableTime: false,
        mode: "single",
        locale: Dutch,
        disable: [...disabled, new Date(), new Date().fp_incr(1), ...blockedNextMonth],
        defaultDate:
          new Date(
            JSON.parse(localStorage.getItem("reservationDates"))?.startDate
          ) ?? new Date().fp_incr(2),
        onReady(_, __, fp) {
          fp.calendarContainer.classList.add("flatpickr-vendor");
          $(".flatpickr-vendor")
            .wrap("<div class='flatpickr-vendor'></div>")
            .removeClass("flatpickr-vendor");
        },
        onMonthChange: function (selectedDates, dateStr, instance) {
          (async () => {
            const tempDisabled = await booking.findAvailableById(
              route.get("id"),
              instance.currentMonth + 1,
              instance.currentYear
            );
            const blockedNextMonth = await nextMonthDisabled(instance.currentMonth + 1, instance.currentYear);

            instance.set("disable", [
              ...disabled,
              ...tempDisabled,
              new Date(),
              new Date().fp_incr(1),
              ...blockedNextMonth,
            ]);
          })();
        },
        onDayCreate: function (dObj, dStr, fp, dayElem) {
          fp.config.disable.forEach(function (dateRange) {
            const from = new Date(dateRange.from);
            const to = new Date(dateRange.to);

            if (dayElem.dateObj >= from && dayElem.dateObj <= to) {
              $(dayElem).addClass("booked-date");
            }
          });
        },
        onChange: function (selectedDates, dateStr, instance) {
          const startDate = instance.formatDate(selectedDates[0], "Y-m-d");

          const reservationDatesData = JSON.parse(
            localStorage.getItem("reservationDates")
          );
          const { endDate } = reservationDatesData || {};

          // if (endDate && endDate < startDate) {
          //   alert("De einddatum moet na de begindatum liggen.");
          //   instance.setDate(reservationDatesData?.endDate || null);
          //   return;
          // }
          console.log(`$("#mobileEndDatePicker")`, $("#mobileEndDatePicker"));

          localStorage.setItem(
            "reservationDates",
            JSON.stringify({
              ...JSON.parse(localStorage.getItem("reservationDates") || "{}"),
              startDate,
              endDate: null,
            })
          );
          $("#mobileEndDatePicker").val(null);

          const startDateText = startDate.split("-").reverse().join("-");
          $(".ReservationInformation__ItemTextValue.StartDate").text(
            startDateText
          );

          handleDisableNextBtnStep1();
          updateReservationInfo();
        },
      });

      // End Date Picker
      // const { startDate } = JSON.parse(
      //   localStorage.getItem("reservationDates") || {}
      // );

      console.log(`$("#mobileEndDatePicker")`, $("#mobileEndDatePicker"));
      flatpickr("#mobileEndDatePicker", {
        dateFormat: "d-m-Y",
        minDate: new Date().fp_incr(1), // End date must be at least 1 day after start date
        enableTime: false,
        mode: "single",
        locale: Dutch,
        disable: [...disabled, new Date(), new Date().fp_incr(1), ...blockedNextMonth],
        defaultDate:
          new Date(
            JSON.parse(localStorage.getItem("reservationDates"))?.endDate
          ) ?? new Date().fp_incr(2),
        onReady(_, __, fp) {
          fp.calendarContainer.classList.add("flatpickr-vendor");
          $(".flatpickr-vendor")
            .wrap("<div class='flatpickr-vendor'></div>")
            .removeClass("flatpickr-vendor");
        },
        onMonthChange: function (selectedDates, dateStr, instance) {
          (async () => {
            const tempDisabled = await booking.findAvailableById(
              route.get("id"),
              instance.currentMonth + 1,
              instance.currentYear
            );

            const blockedNextMonth = await nextMonthDisabled(instance.currentMonth + 1, instance.currentYear);

            instance.set("disable", [
              ...disabled,
              ...tempDisabled,
              new Date(),
              new Date().fp_incr(1),
              ...blockedNextMonth
            ]);
          })();
        },
        onDayCreate: function (dObj, dStr, fp, dayElem) {
          fp.config.disable.forEach(function (dateRange) {
            const from = new Date(dateRange.from);
            const to = new Date(dateRange.to);

            if (dayElem.dateObj >= from && dayElem.dateObj <= to) {
              $(dayElem).addClass("booked-date");
            }
          });
        },
        onChange: function (selectedDates, dateStr, instance) {
          const endDate = instance.formatDate(selectedDates[0], "Y-m-d");
          const reservationDatesData = JSON.parse(
            localStorage.getItem("reservationDates")
          );
          const { startDate } = reservationDatesData || {};

          if (endDate < startDate) {
            // alert("De einddatum moet na de begindatum liggen.");
            instance.setDate(reservationDatesData?.endDate || null);
            localStorage.setItem(
              "reservationDates",
              JSON.stringify({
                ...JSON.parse(localStorage.getItem("reservationDates") || "{}"),
                endDate: null,
              })
            );
            handleDisableNextBtnStep1();
            return;
          }

          localStorage.setItem(
            "reservationDates",
            JSON.stringify({
              ...JSON.parse(localStorage.getItem("reservationDates") || "{}"),
              endDate,
            })
          );

          const endDateText = endDate.split("-").reverse().join("-");
          $(".ReservationInformation__ItemTextValue.EndDate").text(endDateText);

          handleDisableNextBtnStep1();
          updateReservationInfo();
        },
      });

      // Helper Function: Update Reservation Info
      // eslint-disable-next-line no-inner-declarations
      function updateReservationInfo() {
        const reservationDatesData = JSON.parse(
          localStorage.getItem("reservationDates")
        );
        const { startDate, endDate } = reservationDatesData || {};

        if (startDate && endDate) {
          const start = new Date(startDate);
          const end = new Date(endDate);

          const timeDifference = end - start;
          const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

          if (dayDifference < 1) {
            $(el.errorMessage).addClass("active");
          } else {
            $(el.errorMessage).removeClass("active");
          }

          $(".js-AddonsProduct__DiffDays").val(dayDifference + 1);

          // Update Price
          $(inputSelectors.price).text(
            `€${((dayDifference + 1) * initialPrice)
              .toFixed(2)
              .replace(".", ",")}`
          );

          updateTotalPrice();

          $("#deposit_fee").text("€0");

          let totalHuurjs = localStorage.getItem("totalHuurjs");
          let startingPriceFromTotalHuurjs = parseFloat(totalHuurjs);

          $(".ReservationInformation__ItemTextPrice.js-ReservationPrice").text(
            `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
          );
          $(".js-ReservationPrice.Huurprijs").text(
            `€${startingPriceFromTotalHuurjs.toFixed(2).replace(".", ",")}`
          );
        }
      }
      }
      catch (error) {
        console.log(`error`, error);
      }
    });

    $(".DeliveryTooltipTrigger").on("mouseover", function (e) {
      $(".DeliveryTooltip").addClass("active");
    });

    $(".DeliveryTooltipTrigger").on("mouseleave", function (e) {
      $(".DeliveryTooltip").removeClass("active");
    });

    // Helper function to update displayed dates
    function updateDisplayedDates(instance, startDate, endDate) {
      const formattedStartDate = instance.formatDate(startDate, "d-m-Y");
      const formattedEndDate = instance.formatDate(endDate, "d-m-Y");

      $(".ReservationInformation__ItemTextValue.StartDate").text(
        formattedStartDate
      );
      $(".ReservationInformation__ItemTextValue.EndDate").text(
        formattedEndDate
      );
    }

    // Helper function to save dates to localStorage
    function saveDatesToLocalStorage(instance, startDate, endDate) {
      const formattedStartDate = instance.formatDate(startDate, "Y-m-d");
      const formattedEndDate = instance.formatDate(endDate, "Y-m-d");

      localStorage.setItem(
        "reservationDates",
        JSON.stringify({
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        })
      );
    }

    // DATE FLATPICKR STEP 1

    // Load saved dates if available
    const savedDates = JSON.parse(localStorage.getItem("reservationDates"));
    if (savedDates) {
      flatpickr("#wb-DatePicker", {
        defaultDate: [savedDates.startDate, savedDates.endDate],
      });
    }

    // BUTTON NEXT
    $(el.nextBtn).on("click", function () {
      if (currentStep == 1) {
        const urlParams = new URLSearchParams(window.location.search);
        const productId = urlParams.get("id");

        const productTypeItem = {};
        const productType = urlParams.get("product-type");
        productTypeItem[productId] = productType;
        const existingProductType =
          JSON.parse(localStorage.getItem("productType")) || {};

        const updatedProductType = { ...existingProductType, ...productTypeItem };
        
        localStorage.setItem("productId", productId);
        localStorage.setItem("productType", JSON.stringify(updatedProductType));
      }
      if (currentStep === 3) {
        $(this).find("span").text("Afrekenen");

        if (!validateStep2()) {
          return;
        }
      }

      // Save form data for current step
      saveStepData(currentStep);

      if (currentStep < totalSteps) {
        changeStep(currentStep + 1);
      }

      if (currentStep === 2) {
        const theTotalPrice = parseFloat(
          $(".js-totalPriceData")
            .text()
            .replace(/[^\d.-]/g, "")
        );
        localStorage.setItem("theTotalPrice", JSON.stringify(theTotalPrice));

        // Retrieve the data from localStorage
        const reservationData = JSON.parse(
          localStorage.getItem("reservationDates")
        );

        if (reservationData) {
          const { startDate, endDate } = reservationData;

          // Create the new URL with parameters
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set("startDate", startDate);
          currentUrl.searchParams.set("endDate", endDate);

          // Update the URL without reloading the page
          window.history.replaceState({}, "", currentUrl);
        }

        $(".js-LoadingScreen").addClass("active");

        const urlParams = new URLSearchParams(window.location.search);
        const productId = urlParams.get("id");
        const installationFee = $(".js-ProductLists__Item").data("instalation");

        const installationFeesByProduct =
          JSON.parse(localStorage.getItem("installationFeesByProduct")) || {};
        installationFeesByProduct[productId] = installationFee;
        localStorage.setItem(
          "installationFeesByProduct",
          JSON.stringify(installationFeesByProduct)
        );

        setTimeout(function () {
          location.reload();
        }, 500);
        $(".js-LoadingScreen").addClass("active");
      }

      if (currentStep === 3) {
        $(".js-LoadingScreen").addClass("active");

        const theTotalPrice = parseFloat(
          $("#total_price")
            .text()
            .replace(/[^\d.-]/g, "")
        );
        localStorage.setItem("theTotalPrice", JSON.stringify(theTotalPrice));

        setTimeout(function () {
          location.reload();
        }, 1000);
        $(".js-LoadingScreen").addClass("active");
      }

      const reservationDatesData = JSON.parse(
        localStorage.getItem("reservationDates")
      );

      const start = new Date(reservationDatesData.startDate);
      const end = new Date(reservationDatesData.endDate);

      // Calculate the time difference in milliseconds
      const timeDifference = end - start;

      // Convert the time difference from milliseconds to days
      const dayDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
      $(".js-AddonsProduct__DiffDays").val(dayDifference);
      const diffDayVal = reformatPriceToInt(
        $(".js-AddonsProduct__DiffDays").val()
      );

      $(".js-AddonsPrice").each(function () {
        const priceEachItem = reformatPriceToInt($(this).text());
        const priceAddonsMultiple =
          priceEachItem + (priceEachItem / 2) * (diffDayVal - 1);
        $(this).text(`€${priceAddonsMultiple.toFixed(2).replace(".", ",")}`);
      });

      const productTypeData = JSON.parse(
        localStorage.getItem("productType") || "{}"
      );

      const hasFigure = Object.values(productTypeData).some(
        (value) => value === "figure"
      );
      const allFiguresOrEmpty = Object.values(productTypeData).every(
        (value) => value === "figure"
      );
      console.log("hasFigure", hasFigure);
      if (hasFigure) {
        console.log(hasFigure);

        // $(".js-DeliveryOptions").addClass("active");
        $(".js-GreetingText").addClass("active");
        console.log(hasFigure);

        if (allFiguresOrEmpty) {
          // $(".js-DeliveryOptions").addClass("active");
        } else {
          // $(".js-DeliveryOptions").addClass("active");
          // $(".js-GreetingText").addClass("active");
          console.log("not " + allFiguresOrEmpty);
          // $(".js-DeliveryOptions").removeClass("active");
          // $(".js-DeliveryOptions").addClass("active");
        }
        console.log("has active: " + $(".js-GreetingText").hasClass("active"));
      }

      if (currentStep === 2) {
        const currentUrlCart = window.location.href;
        localStorage.setItem("urlCart", currentUrlCart);
      }
    });

    const reservationDatesData = JSON.parse(
      localStorage.getItem("reservationDates")
    );

    const start = new Date(reservationDatesData.startDate);
    const end = new Date(reservationDatesData.endDate);

    // Calculate the time difference in milliseconds
    const timeDifference = end - start;

    $("#deposit_fee").text("€0");
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
    $(".js-AddonsProduct__DiffDays").val(dayDifference);
    const diffDayVal = reformatPriceToInt(
      $(".js-AddonsProduct__DiffDays").val()
    );
    $(".js-AddonsPrice").each(function () {
      // const priceAddonsId = $(this).data('product-id');
      const priceEachItem = reformatPriceToInt($(this).text());
      const priceAddonsMultiple =
        priceEachItem + (priceEachItem / 2) * (diffDayVal - 1);
      $(this).text(`€${priceAddonsMultiple.toFixed(2).replace(".", ",")}`);
    });

    // BUTTON PREV
    $(el.prevBtn).on("click", function () {
      $(document).ready(function () {
        $("#wb-DatePicker").trigger("change");
      });

      if (currentStep > 1) {
        changeStep(currentStep - 1);
      }

      if (currentStep === 1) {
        localStorage.clear();
        localStorage.setItem("currentStep", currentStep);
        // let reloadCount = sessionStorage.getItem('reloadCount') || 0;

        $(".js-LoadingScreen").addClass("active");
        sessionStorage.setItem("reloadForPrevStep", currentStep - 1);

        setTimeout(function () {
          location.reload();
        }, 500);
        $(".js-LoadingScreen").addClass("active");
      }

      if (currentStep === 2) {
        // * Currently unuse
        // const { startDate, endDate } = JSON.parse(
        //   localStorage.getItem("reservationDates")
        // );
        // localStorage.clear();
        // localStorage.setItem("currentStep", currentStep);
        // localStorage.setItem("reservationDates", JSON.stringify({ startDate }));
        // $(".js-LoadingScreen").addClass("active");
        // setTimeout(function () {
        //   location.reload();
        // }, 1000);
        // $(".js-LoadingScreen").addClass("active");
      }
    });

    // FUNCTION FORM VALIDATION STEP 2
    function validateStep2() {
      let isValid = true;
      const requiredFields = $(el.bookingFormReserveren).find(
        "input[required], select[required], textarea[required], input[type='radio']"
      );

      requiredFields.each(function () {
        if (!this.checkValidity()) {
          isValid = false;
          $(this).siblings().show();
        } else {
          $(this).siblings(".FormField__Helper").hide();
        }
      });

      if (!isValid) {
        // console.log("Please fill out all required fields.");
      }

      return isValid;
    }

    // FUNCTION STEPS
    function changeStep(step) {
      currentStep = step;

      // Save the current step to localStorage
      localStorage.setItem("currentStep", currentStep);

      // Reset all steps
      $(el.firstStep).removeClass("active");
      $(el.secondStep).removeClass("active");
      $(el.thirdStep).removeClass("active");
      $(el.forthStep).removeClass("active");
      $(el.cartStep).removeClass("active");

      // Add active class to the current step
      if (currentStep === 1) {
        $(el.firstStep).addClass("active");
        $(el.forthStep).parent().removeClass("LastStep");
        $(el.reserverenStepsCount).text("Stap " + currentStep);

        // Change text
        $(el.reserverenBodyTitle).find("h3").text("Selecteer een datum");
        $(el.nextBtn).find("span").text("Volgende");
      } else if (currentStep === 2) {
        $(el.cartStep).addClass("active");
        $(el.forthStep).parent().removeClass("LastStep");
        $(el.reserverenStepsCount).text("Stap " + currentStep);
        $(el.reserverenBodyTitle).find("h3").text("Winkel");
        loadStepData(currentStep); // Load saved data for this step
      } else if (currentStep === 3) {
        $(el.secondStep).addClass("active");
        $(el.forthStep).parent().removeClass("LastStep");
        $(el.reserverenStepsCount).text("Stap " + currentStep);
        loadStepData(currentStep); // Load saved data for this step

        // Change text
        $(el.reserverenBodyTitle)
          .find("h3")
          .text("Vul persoonlijke gegevens in");
        $(el.nextBtn).find("span").text("Afrekenen");
      } else if (currentStep === 4) {
        $(el.forthStep).addClass("active");
        $(el.forthStep).parent().addClass("LastStep");
        $(el.reserverenBodyTitle).remove();
        $(el.reserverenBodyTitle)
          .find("h3")
          .text("Vul persoonlijke gegevens in");

        loadStepData(currentStep);
      }

      $(el.stepsHeaderItems).each(function (index) {
        if (index < currentStep - 1) {
          $(this).find("span:first-child").hide();
          $(this).find(".success").addClass("active");
        } else if (index === currentStep - 1) {
          $(this).addClass("active");
          $(this).find("span:first-child").show();
          $(this).find(".success").removeClass("active");
        } else {
          $(this).removeClass("active");
          $(this).find("span:first-child").show();
          $(this).find(".success").removeClass("active");
        }
      });

      updateButtonState();
    }

    // FUNCTION BUTTON STATE
    function updateButtonState() {
      if (currentStep === 1) {
        $(el.prevBtn).removeClass("active");
      } else {
        $(el.prevBtn).addClass("active");
      }

      if (currentStep === totalSteps) {
        $(el.nextBtn).addClass("submit").addClass("active");
        $(el.reserverenBtnWrapper).remove();
      } else if (currentStep === 1) {
        $(el.nextBtn).removeClass("active").removeClass("submit");
      } else {
        $(el.nextBtn).addClass("active").removeClass("submit");
      }
    }

    function saveStepData(step) {
      const formData = {};
      $(el.bookingFormReserveren)
        .find(
          "input, select, textarea, input[type='checkbox'], input[type='radio']"
        )
        .each(function () {
          const $input = $(this);
          if ($input.is(":radio")) {
            // Only set value if the radio button is selected
            if ($input.is(":checked")) {
              formData[$input.attr("name")] = $input.val();
            }
          } else {
            formData[$input.attr("name")] = $input.val();
          }
        });

      formData.payment_method = $("input[name=payment_method]:checked").val();

      if (step === 1) {
        // Store productId separately if it's step 1
        const step1Data = { productId: localStorage.getItem("productId") };
        localStorage.setItem(`step${step}Data`, JSON.stringify(step1Data));
      } else {
        localStorage.setItem(`step${step}Data`, JSON.stringify(formData));
      }
    }

    // FUNCTION TO LOAD STEP DATA
    function loadStepData(step) {
      const savedData = JSON.parse(localStorage.getItem(`step${step}Data`));
      if (savedData) {
        for (const name in savedData) {
          $(`[name="${name}"]`).val(savedData[name]);
        }

        if (savedData.address) {
          $(el.inputAddress).text(savedData.address);
        }
      }
    }

    // FUNCTION TO GATHER ALL DATA FROM LOCALSTORAGE
    function gatherAllStepData() {
      const step1Data = JSON.parse(localStorage.getItem("step1Data")) || {};
      const step2Data = JSON.parse(localStorage.getItem("step3Data")) || {};
      const reservationDates =
        JSON.parse(localStorage.getItem("reservationDates")) || {};

      return { ...step1Data, ...step2Data, ...reservationDates };
    }

    // SEND DATA ON STEP 3 BUTTON CLICK
    $(function () {
      $(document).on("click", ".js-ReserverenButton__Next.submit", function () {
        const ajax = themeObj.ajaxBookingReserveren;
        const allData = gatherAllStepData();
        const deliveryFee = $(
          ".ReservationInformation__ItemTextValue.js-DeliveryFee"
        ).html();

        const data = {
          action: ajax.action,
          nonce: ajax.nonce,
          allData: allData,
          deliveryFee: deliveryFee,
        };

        $.ajax({
          url: themeObj.ajaxUrl,
          type: "POST",
          data: data,
          success: function (res) {
            localStorage.clear();
            const url = res.data;
            if (res.success) {
              window.location.href = url;
            } else {
              alert("Er ging iets mis");
            }
          },
          error: function (error) {
            console.error("Error sending data", error);
          },
        });
      });
    });

    // LOCALSTORAGE STEPPER
    const savedStep = localStorage.getItem("currentStep");
    if (savedStep) {
      currentStep = parseInt(savedStep);
      changeStep(currentStep);
    } else {
      changeStep(1);
    }

    $(el.paymentSuccessBtn).on("click", function () {
      e.preventDefault();
    });

    // GET DATA FROM LOCALSTORAGE WHEN PAGE GOT REFRESH
    $(function () {
      const step2Data = JSON.parse(localStorage.getItem("step2Data"));
      const reservationDates = JSON.parse(
        localStorage.getItem("reservationDates")
      );

      if (step2Data) {
        $(el.inputAddress).text(step2Data.address);
      }
      if (reservationDates) {
        $(".ReservationInformation__ItemTextValue.StartDate").text(
          reservationDates.startDate
        );
        $(".ReservationInformation__ItemTextValue.EndDate").text(
          reservationDates.endDate
        );
      }
    });

    $(el.bookingForm).on(
      "change",
      ".js-DeliveryOptions input[type='radio']",
      function () {
        let deliveryFeeLocalstorage = parseFloat(
          localStorage.getItem("deliveryFee") || 0
        );
        let totalPrice = parseFloat(localStorage.getItem("totalPrice") || 0);
        let theTotalPriceWithDelivery = parseFloat(
          localStorage.getItem("theTotalPriceWithDelivery") || 0
        );

        if (!localStorage.getItem("initialDeliveryFee")) {
          localStorage.setItem("initialDeliveryFee", deliveryFeeLocalstorage);
        }
        // console.log(theTotalPriceWithDelivery)
        const initialDeliveryFee = parseFloat(
          localStorage.getItem("initialDeliveryFee") || 0
        );
        const isPickupSelected = $(this).val() === "pickup";

        if (isPickupSelected) {
          $(".installment-item, .js-DeliveryFeeItem").addClass("active");
          $(".js-DeliveryOptions .delivery").removeClass("active");
          $(".js-DeliveryOptions .pickup").addClass("active");

          $(".js-totalPriceData").text(
            `€${totalPrice.toFixed(2).replace(".", ",")}`
          );

          localStorage.setItem("deliveryFee", 0);
        } else {
          $(".installment-item, .js-DeliveryFeeItem").removeClass("active");
          $(".js-DeliveryOptions .pickup").removeClass("active");
          $(".js-DeliveryOptions .delivery").addClass("active");

          $(".js-totalPriceData").text(
            `€${theTotalPriceWithDelivery.toFixed(2).replace(".", ",")}`
          );

          localStorage.setItem("deliveryFee", initialDeliveryFee);
        }
      }
    );
    // console.log('masoks');

    // Initialize delivery option as active on page load
    $(".js-DeliveryOptions .delivery").addClass("active");
    // console.log(`$(".js-DeliveryOptions .delivery")`, $(".js-DeliveryOptions .delivery"));
  };

  if (localStorage.getItem("theTotalPriceWithDelivery")) {
    localStorage.removeItem("theTotalPriceWithDelivery");
  }

  const inputSelectors = {
    price: ".js-ReservationPrice",
    installationFee: "#installation_fee",
    deliveryFee: ".ReservationInformation__ItemTextValue.js-DeliveryFee",
    depositFee: "#deposit_fee",
    totalPrice: "#total_price",
    totalPriceCart: ".js-totalPrice",
    pricePerItem: ".js-ProductLists .ReservationInformation__ItemText",
  };

  const reformatPriceToInt = (price = "") => {
    if (typeof price !== "string") return;

    return +price.split(",")[0].replace("€", "").trim();
  };

  const updateTotalPrice = (deliveryFee = 0) => {
    const installationFee = $(".js-ProductLists__Item").data("instalation");
    const diffDayVal = reformatPriceToInt(
      $(".js-AddonsProduct__DiffDays").val()
    ); // ?????

    const price = reformatPriceToInt($(inputSelectors.price).text());
    const addonItems = {};

    $(inputSelectors.pricePerItem).each(function () {
      const diffDayVal = reformatPriceToInt(
        $(".js-AddonsProduct__DiffDays").val()
      ); // ?????
      const addonsItemId = $(this).data("product-id");
      const priceEachItem = reformatPriceToInt(
        $(this)
          .find(".ReservationInformation__ItemTextPrice.js-ReservationPrice")
          .text()
      );

      const priceEachItemCalculated = priceEachItem / diffDayVal;
      // console.log(`Adding ${priceEachItem} to ${JSON.stringify(addonItems)}`);

      if (addonsItemId) {
        addonItems[addonsItemId] =
          priceEachItemCalculated +
          (priceEachItemCalculated / 2) * (diffDayVal - 1);
      }
    });

    let priceNewCalculated = price / diffDayVal;
    const totalAmount =
      priceNewCalculated +
      (priceNewCalculated / 2) * (diffDayVal - 1) +
      installationFee;

    const originalPrice = priceNewCalculated;
    const totalPrice = totalAmount;
    const totalPriceElement = $(inputSelectors.totalPrice);
    const totalPriceCartElement = $(inputSelectors.totalPriceCart);
    // console.log(
    //   `priceNewCalculated: ${priceNewCalculated}, totalPrice: ${totalPrice}`
    // );

    const totalHuurjsNew =
      priceNewCalculated + (priceNewCalculated / 2) * (diffDayVal - 1);

    totalPriceElement.text(`€${totalAmount.toFixed(2).replace(".", ",")}`);
    totalPriceCartElement.text(`€${totalAmount.toFixed(2).replace(".", ",")}`);
    // Store the values in an object before converting to JSON
    const priceData = {
      price: totalAmount,
      totalAmount: totalAmount,
      originalPrice: originalPrice,
      totalHuurjs: totalHuurjsNew,
      totalPrice: totalHuurjsNew,
    };
    localStorage.setItem("priceOrders", JSON.stringify(priceData));
    localStorage.setItem("addonsPrices", JSON.stringify(addonItems));
    localStorage.setItem("originalPrice", JSON.stringify(originalPrice));
    localStorage.setItem("totalHuurjs", JSON.stringify(totalHuurjsNew));
    localStorage.setItem("totalPrice", JSON.stringify(totalPrice));
    $(".js-totalPriceData").text(`€${totalPrice.toFixed(2).replace(".", ",")}`);
    console.log(`installationFee is ${installationFee}`);
  };

  $(document).ready(function () {
    if ($("#wb-DatePicker").length) {
      $("#wb-DatePicker").trigger("change");
    }

    const savedPriceData = JSON.parse(localStorage.getItem("priceOrders"));
    const savedAddonPrices = JSON.parse(localStorage.getItem("addonsPrices"));

    // Check if there is saved price data
    if (savedPriceData) {
      $(inputSelectors.price).text(
        `€${savedPriceData.price.toFixed(2).replace(".", ",")}`
      );
      $(inputSelectors.totalPrice).text(
        `€${savedPriceData.price.toFixed(2).replace(".", ",")}`
      );
      $(inputSelectors.totalPriceCart).text(
        `€${savedPriceData.price.toFixed(2).replace(".", ",")}`
      );
    }

    // const listAddons = $(".js-ProductLists__Item .ReservationInformation__ItemTextPrice.js-ReservationPrice");
    const currentStep = localStorage.getItem("currentStep");

    function updatePrices() {
      // Retrieve and parse the addonsPrices data for individual item prices
      let addonsPricesData =
        JSON.parse(localStorage.getItem("addonsPrices")) || {};

      // Calculate the total sum only once from the prices array
      const pricesArray = Object.values(addonsPricesData);
      const totalSum = pricesArray.reduce(
        (acc, price) => acc + parseFloat(price),
        0
      );

      // Display each item’s individual price
      for (let productId in addonsPricesData) {
        const itemPrice = parseFloat(addonsPricesData[productId])
          .toFixed(2)
          .replace(".", ",");
        $(
          `.js-BookingCart__Card[data-product-id="${productId}"] .item-price`
        ).text(`€${itemPrice}`);
      }

      // Display the total sum in the intended element
      $("#total_price.totalPrice").text(
        `€${totalSum.toFixed(2).replace(".", ",")}`
      );
    }

    // Check if there are saved addon prices
    if (savedAddonPrices) {
      // Iterate over the saved addon prices
      $.each(savedAddonPrices, function (productId, price) {
        // Find the corresponding element with the data-product-id
        const $itemElement = $(
          `.js-ProductLists .ReservationInformation__ItemText[data-product-id="${productId}"]`
        );

        // Update the price text for each item based on the saved price
        if ($itemElement.length) {
          $itemElement
            .find(".js-ReservationPrice")
            .text(`€${price.toFixed(2).replace(".", ",")}`);
        }
      });
    }

    // Prijs & Subtotaal
    let originalPrice = localStorage.getItem("originalPrice");
    let originalPriceData = JSON.parse(originalPrice);

    const diffDayVal = reformatPriceToInt(
      $(".js-AddonsProduct__DiffDays").val()
    );

    let productPriceNormal =
      originalPriceData + (originalPriceData / 2) * (diffDayVal - 1);

    $(".js-BookingCart__Item .js-ReservationPrice").text(
      `€${parseFloat(originalPriceData).toFixed(2).replace(".", ",")}`
    );
    $(".js-BookingCart__Item .js-totalPrice").text(
      `€${parseFloat(productPriceNormal).toFixed(2).replace(".", ",")}`
    );
    $("#total_price").text(originalPriceData);

    if (currentStep === 3) {
      updatePrices();
    }
  });

  const getDeliveryFee = () => {
    $(document).on("change", ".address-input", function () {
      let address = "";
      let all = 1;

      $(".address-input").each((i, e) => {
        address += $(e).val() + " ";

        if ($(e).val() == "") all = 0;
      });

      if (all == 1) {
        const data = {
          action: $("#action").val(),
          nonce: $("#_token").val(),
          address: address,
        };

        $.ajax({
          type: "POST",
          url: themeObj.ajaxUrl,
          data: data,
        }).done((res) => {
          let deliveryFee = res.data;

          deliveryFee = deliveryFee.toFixed(2);
          deliveryFee = deliveryFee.replace(".", ",");

          $(inputSelectors.deliveryFee).text(`€${deliveryFee}`);
          // updateTotalPrice(deliveryFee);

          if (!isNaN(deliveryFee)) {
            localStorage.setItem("deliveryFee", deliveryFee);
          }

          let address = $("#address").val();
          $(".ReservationInformation__ItemTextValue.js-AddressItemValue").text(
            address
          );

          let theTotalPriceLocalstorage = localStorage.getItem("totalPrice");
          let calculationFeeDelivery =
            parseFloat(theTotalPriceLocalstorage) + parseFloat(deliveryFee);
          localStorage.setItem(
            "theTotalPriceWithDelivery",
            calculationFeeDelivery
          );

          if (localStorage.getItem("theTotalPriceWithDelivery")) {
            let priceWithDelivery = parseFloat(
              localStorage.getItem("theTotalPriceWithDelivery")
            );
            $(".js-totalPriceData").text(
              `€${priceWithDelivery.toFixed(2).replace(".", ",")}`
            );
          } else {
            let priceWithDelivery = parseFloat(
              localStorage.getItem("theTotalPrice")
            );
            $(".js-totalPriceData").text(
              `€${priceWithDelivery.toFixed(2).replace(".", ",")}`
            );
          }
        });
      }
    });
  };

  const handleShowReservationNotes = () => {
    const cardElement = $(el.reservationNotes);
    if (cardElement.length == 0) return;
    const currentStep = localStorage.getItem("currentStep");
    if (currentStep != 1) cardElement.hide();
  };

  const handleShowMobileInput = () => {
    const currWidth = $(window).width();
    const currentStep = localStorage.getItem("currentStep");

    const elMobilePicker = $(`.DatePickerWrapper.isMobilePicker`);
    const elDesktopPicker = $(`.DatePickerWrapper.js-DatePickerWrapper`);
    if (currWidth < 600 && currentStep <= 1) {
      elMobilePicker.show();
      elDesktopPicker.hide();
    }
  };

  const handleDisableNextBtnStep1 = () => {
    const reservationDatesData =
      JSON.parse(localStorage.getItem("reservationDates")) || {};
    const { startDate, endDate } = reservationDatesData;
    const currentStep = parseInt(localStorage.getItem("currentStep"), 10); // Parse as integer for safety

    if (currentStep === 1) {
      if (startDate && endDate) {
        $(el.nextBtn).addClass("active");
      } else {
        $(el.nextBtn).removeClass("active");
      }
    }
  };

  init();
};

try {
  bookingReserveren();
} catch (error) {
  throw Error(error);
}
